import React from 'react'
import { ReactComponent as NetworkIcon } from '../../icons/nav_net.svg'
import { ReactComponent as CablesIcon } from '../../icons/nav_cables.svg'
import { ReactComponent as IpIcon } from '../../icons/nav_ip.svg'
import { ReactComponent as CapacityIcon } from '../../icons/nav_capacity.svg'
import { ReactComponent as ColocationIcon } from '../../icons/nav_colocation.svg'

import styled, { css } from 'styled-components'
const LayerBit = styled.div`
  height: 40px;
  margin: 0rem 0 1.6rem;
  padding: 0.2rem 1rem;
  text-align: left;
  cursor: pointer;
  opacity: 1;
  transition: opacity 1s;
  transition-delay: 2s;
  pointer-events: all;

  ${props =>
    props.isSelected &&
    css`
      margin: 0rem 0rem 1.6rem 0.5rem;
      padding-left: 0.5rem;
      border-left: 3px solid #fff;
    `};
`

const LayerIcon = styled.div`
  width: 24px;
  height: 24px;
  padding: 0.5rem;
  float: left;
  background: #fff;
  border-radius: 1rem;
  pointer-events: none;
`

const LayerDesc = styled.div`
  margin-left: 8px;
  float: left;
  clear: right;
  width: 90px;
  pointer-events: none;
  cursor: pointer;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

const LayerTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

const LayerSubtitle = styled.div`
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #a4a4a4;
  cursor: pointer;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

const LayerItem = ({ item, isSelected, urlTo, nextLevel, close, id }) => {
  const handleClick = e => {
    urlTo(item.layer, '', '')
    item.title !== 'Network map' && nextLevel()
    console.log(item);
  }
  return (
    <LayerBit isSelected={isSelected} layer={item.layer} data-ga-menu-layer={item.layer} id={id} onClick={e => handleClick(e)}>
      <LayerIcon>
        {item.title === 'Network map' ? (
          <NetworkIcon />
        ) : item.title === 'Cables' ? (
          <CablesIcon />
        ) : item.title === 'IP' ? (
          <IpIcon />
        ) : item.title === 'Capacity' ? (
          <CapacityIcon />
        ) : (
          <ColocationIcon />
        )}
      </LayerIcon>
      <LayerDesc>
        <LayerTitle>{item.title}</LayerTitle>
        <LayerSubtitle>{item.desc}</LayerSubtitle>
      </LayerDesc>
    </LayerBit>
  )
}

export default LayerItem
